<script lang="ts">
	export let value = 0;
</script>

<div class="fullwidth">
	<div class="mdc-typography--headline5 text-wrap">{value} %</div>
	<input class="slider" type="range" min="0" max="100" step={1} bind:value />
</div>

<style>
	div {
		display: inline-flex;
		align-items: center;
	}

	.text-wrap {
		width: 85px;
	}

	input {
		-webkit-appearance: none;
		width: 100%;
		height: 15px;
		border-radius: 5px;
		background: #d3d3d3;
		outline: none;
		opacity: 0.7;
		-webkit-transition: 0.2s;
		transition: opacity 0.2s;
		margin-left: 1rem;
		flex-grow: 1;
	}

	input:hover {
		opacity: 1;
	}

	input::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background: var(--mdc-theme-primary);
		cursor: pointer;
	}

	input::-moz-range-thumb {
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background: var(--mdc-theme-primary);
		cursor: pointer;
	}
</style>
